export default __webpack_public_path__ + "static/media/DE.d1074783.svg";